import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import styles from './InputSelect.module.scss'

export default class InputSelect extends React.Component {
  // constructor(props) {
  //   super(props)

  //   this.state = {
  //     value: props.value || '',
  //   }
  // }
//
  // componentWillReceiveProps(nextProps) {
  //   this.setState({ value: nextProps.value || '' })
  // }

  render() {
    //const { entity, onChange, options, placeholder, value } = this.props
    //const { entity, options, placeholder, value = '0', ...props } = this.props
    const { entity, options, placeholder, ...props } = this.props
    //const { entity, options, placeholder, value: noValue, ...props } = this.props
    //const { entity, onChange, options, placeholder } = this.props
    //let { value } = this.state
    let _placeholder = placeholder || 'Select…'

    if (entity && !placeholder) {
      _placeholder = `Select ${entity}…`
    }

    //console.log('...props', props)
    // console.log('this.props', this.props)
    // console.log('this.props.value', this.props.value)

    //const myValue = value === '' ? null : value

    return (
      <div className={classNames('InputSelect', styles.this)}>
        <select {...props}>
          <option value="">
            {_placeholder}
          </option>
          {options.map((option) => {
            const _value = option.value || option.option

            return (
              <option value={_value} key={_value}>
                {option.option}
              </option>
            )
          })}
        </select>
      </div>
    )
  }
}

InputSelect.propTypes = {
  entity: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/InputSelect/InputSelect.js